/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * App 内嵌终端：product_detail_app（由同名 WAP 终端全量派生，B 位 *_wap 重写为 product_detail_app，C/D 不变；136 个 D 位坑位，14 个 C 位模块）。
 * 数据源：product_detail_wap（全量派生）。
 * 曝光事件上报模块编码（module.code，A.B.C）；点击事件上报坑位完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_DETAIL_APP_SPM_CODES = {
  accessory_recommendations: {
    code: `${sitePrefix}.product_detail_app.accessory_recommendations`,
    add_to_cart_001: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_001`,
    add_to_cart_002: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_002`,
    add_to_cart_003: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_003`,
    add_to_cart_004: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_004`,
    add_to_cart_005: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_005`,
    add_to_cart_006: `${sitePrefix}.product_detail_app.accessory_recommendations.add_to_cart_006`,
    favorite_001: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_001`,
    favorite_002: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_002`,
    favorite_003: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_003`,
    favorite_004: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_004`,
    favorite_005: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_005`,
    favorite_006: `${sitePrefix}.product_detail_app.accessory_recommendations.favorite_006`,
    preview_accessory_001: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_001`,
    preview_accessory_002: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_002`,
    preview_accessory_003: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_003`,
    preview_accessory_004: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_004`,
    preview_accessory_005: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_005`,
    preview_accessory_006: `${sitePrefix}.product_detail_app.accessory_recommendations.preview_accessory_006`,
  },
  color_variants: {
    code: `${sitePrefix}.product_detail_app.color_variants`,
    select_variant_01: `${sitePrefix}.product_detail_app.color_variants.select_variant_01`,
    select_variant_02: `${sitePrefix}.product_detail_app.color_variants.select_variant_02`,
  },
  frame_specifications: {
    code: `${sitePrefix}.product_detail_app.frame_specifications`,
    open_product_details: `${sitePrefix}.product_detail_app.frame_specifications.open_product_details`,
    show_pd_range_help: `${sitePrefix}.product_detail_app.frame_specifications.show_pd_range_help`,
    show_progressive_help: `${sitePrefix}.product_detail_app.frame_specifications.show_progressive_help`,
    show_rx_range_help: `${sitePrefix}.product_detail_app.frame_specifications.show_rx_range_help`,
    toggle_measurement_unit: `${sitePrefix}.product_detail_app.frame_specifications.toggle_measurement_unit`,
    toggle_specifications: `${sitePrefix}.product_detail_app.frame_specifications.toggle_specifications`,
  },
  installment_information: {
    code: `${sitePrefix}.product_detail_app.installment_information`,
    open_installment_details: `${sitePrefix}.product_detail_app.installment_information.open_installment_details`,
  },
  lens_availability: {
    code: `${sitePrefix}.product_detail_app.lens_availability`,
    open_lens_details: `${sitePrefix}.product_detail_app.lens_availability.open_lens_details`,
    toggle_lens_availability: `${sitePrefix}.product_detail_app.lens_availability.toggle_lens_availability`,
  },
  price_offers: {
    code: `${sitePrefix}.product_detail_app.price_offers`,
    open_coupons: `${sitePrefix}.product_detail_app.price_offers.open_coupons`,
    open_second_frame_offer: `${sitePrefix}.product_detail_app.price_offers.open_second_frame_offer`,
  },
  product_gallery: {
    code: `${sitePrefix}.product_detail_app.product_gallery`,
    preview_image_001: `${sitePrefix}.product_detail_app.product_gallery.preview_image_001`,
    preview_image_002: `${sitePrefix}.product_detail_app.product_gallery.preview_image_002`,
    preview_image_003: `${sitePrefix}.product_detail_app.product_gallery.preview_image_003`,
    preview_image_004: `${sitePrefix}.product_detail_app.product_gallery.preview_image_004`,
    preview_image_005: `${sitePrefix}.product_detail_app.product_gallery.preview_image_005`,
    preview_image_006: `${sitePrefix}.product_detail_app.product_gallery.preview_image_006`,
    toggle_dimensions_01: `${sitePrefix}.product_detail_app.product_gallery.toggle_dimensions_01`,
    toggle_dimensions_02: `${sitePrefix}.product_detail_app.product_gallery.toggle_dimensions_02`,
    try_on: `${sitePrefix}.product_detail_app.product_gallery.try_on`,
  },
  product_quality: {
    code: `${sitePrefix}.product_detail_app.product_quality`,
    toggle_quality_details: `${sitePrefix}.product_detail_app.product_quality.toggle_quality_details`,
  },
  product_summary: {
    code: `${sitePrefix}.product_detail_app.product_summary`,
    view_reviews: `${sitePrefix}.product_detail_app.product_summary.view_reviews`,
  },
  recommended_products: {
    code: `${sitePrefix}.product_detail_app.recommended_products`,
    color_swatch_001_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_001_02`,
    color_swatch_001_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_001_03`,
    color_swatch_002_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_002_02`,
    color_swatch_003_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_003_03`,
    color_swatch_004_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_004_03`,
    color_swatch_005_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_005_03`,
    color_swatch_006_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_006_01`,
    color_swatch_006_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_006_02`,
    color_swatch_006_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_006_03`,
    color_swatch_007_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_007_01`,
    color_swatch_007_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_007_02`,
    color_swatch_007_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_007_03`,
    color_swatch_008_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_008_01`,
    color_swatch_008_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_008_02`,
    color_swatch_008_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_008_03`,
    color_swatch_009_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_009_01`,
    color_swatch_009_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_009_02`,
    color_swatch_009_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_009_03`,
    color_swatch_010_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_010_01`,
    color_swatch_010_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_010_02`,
    color_swatch_010_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_010_03`,
    color_swatch_011_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_011_01`,
    color_swatch_011_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_011_02`,
    color_swatch_011_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_011_03`,
    color_swatch_012_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_012_01`,
    color_swatch_012_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_012_02`,
    color_swatch_012_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_012_03`,
    color_swatch_013_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_013_01`,
    color_swatch_013_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_013_02`,
    color_swatch_013_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_013_03`,
    color_swatch_014_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_014_01`,
    color_swatch_014_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_014_02`,
    color_swatch_014_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_014_03`,
    color_swatch_015_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_015_01`,
    color_swatch_015_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_015_02`,
    color_swatch_015_03: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_015_03`,
    color_swatch_016_01: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_016_01`,
    color_swatch_016_02: `${sitePrefix}.product_detail_app.recommended_products.color_swatch_016_02`,
    favorite_001: `${sitePrefix}.product_detail_app.recommended_products.favorite_001`,
    favorite_002: `${sitePrefix}.product_detail_app.recommended_products.favorite_002`,
    favorite_003: `${sitePrefix}.product_detail_app.recommended_products.favorite_003`,
    favorite_004: `${sitePrefix}.product_detail_app.recommended_products.favorite_004`,
    favorite_005: `${sitePrefix}.product_detail_app.recommended_products.favorite_005`,
    favorite_006: `${sitePrefix}.product_detail_app.recommended_products.favorite_006`,
    favorite_007: `${sitePrefix}.product_detail_app.recommended_products.favorite_007`,
    favorite_008: `${sitePrefix}.product_detail_app.recommended_products.favorite_008`,
    favorite_009: `${sitePrefix}.product_detail_app.recommended_products.favorite_009`,
    favorite_010: `${sitePrefix}.product_detail_app.recommended_products.favorite_010`,
    favorite_011: `${sitePrefix}.product_detail_app.recommended_products.favorite_011`,
    favorite_012: `${sitePrefix}.product_detail_app.recommended_products.favorite_012`,
    favorite_013: `${sitePrefix}.product_detail_app.recommended_products.favorite_013`,
    favorite_014: `${sitePrefix}.product_detail_app.recommended_products.favorite_014`,
    favorite_015: `${sitePrefix}.product_detail_app.recommended_products.favorite_015`,
    favorite_016: `${sitePrefix}.product_detail_app.recommended_products.favorite_016`,
    product_001: `${sitePrefix}.product_detail_app.recommended_products.product_001`,
    product_002: `${sitePrefix}.product_detail_app.recommended_products.product_002`,
    product_003: `${sitePrefix}.product_detail_app.recommended_products.product_003`,
    product_004: `${sitePrefix}.product_detail_app.recommended_products.product_004`,
    product_005: `${sitePrefix}.product_detail_app.recommended_products.product_005`,
    product_006: `${sitePrefix}.product_detail_app.recommended_products.product_006`,
    product_007: `${sitePrefix}.product_detail_app.recommended_products.product_007`,
    product_008: `${sitePrefix}.product_detail_app.recommended_products.product_008`,
    product_009: `${sitePrefix}.product_detail_app.recommended_products.product_009`,
    product_010: `${sitePrefix}.product_detail_app.recommended_products.product_010`,
    product_011: `${sitePrefix}.product_detail_app.recommended_products.product_011`,
    product_012: `${sitePrefix}.product_detail_app.recommended_products.product_012`,
    product_013: `${sitePrefix}.product_detail_app.recommended_products.product_013`,
    product_014: `${sitePrefix}.product_detail_app.recommended_products.product_014`,
    product_015: `${sitePrefix}.product_detail_app.recommended_products.product_015`,
    product_016: `${sitePrefix}.product_detail_app.recommended_products.product_016`,
  },
  review_summary: {
    code: `${sitePrefix}.product_detail_app.review_summary`,
    preview_review_image_01: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_01`,
    preview_review_image_02: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_02`,
    preview_review_image_03: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_03`,
    preview_review_image_04: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_04`,
    preview_review_image_05: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_05`,
    preview_review_image_06: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_06`,
    preview_review_image_07: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_07`,
    preview_review_image_08: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_08`,
    preview_review_image_09: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_09`,
    preview_review_image_10: `${sitePrefix}.product_detail_app.review_summary.preview_review_image_10`,
    view_featured_review: `${sitePrefix}.product_detail_app.review_summary.view_featured_review`,
    view_reviews: `${sitePrefix}.product_detail_app.review_summary.view_reviews`,
  },
  services_guarantees: {
    code: `${sitePrefix}.product_detail_app.services_guarantees`,
    open_services_details: `${sitePrefix}.product_detail_app.services_guarantees.open_services_details`,
    toggle_services_guarantees: `${sitePrefix}.product_detail_app.services_guarantees.toggle_services_guarantees`,
  },
  size_guide_entry: {
    code: `${sitePrefix}.product_detail_app.size_guide_entry`,
    open_size_chart: `${sitePrefix}.product_detail_app.size_guide_entry.open_size_chart`,
  },
  sticky_purchase: {
    code: `${sitePrefix}.product_detail_app.sticky_purchase`,
    favorite: `${sitePrefix}.product_detail_app.sticky_purchase.favorite`,
  },
} as const satisfies SpmPageCodes;
